const data = {
  tipos_de_violencia: [
    {
      titulo: "VIOLENCIA ECONÓMICA",
      texto:
        "Es toda acción u omisión de la persona agresora, que afecta la supervivencia económica de la mujer, la cual se manifiesta a través de actos encaminados a limitar, controlar o impedir el ingreso de sus percepciones económicas.",
      url_imagen: "/assets/images/violencia/Economica.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        { texto: "Negar la cuota alimenticia." },
        { texto: "No aportar dinero al hogar." },
        { texto: "Retener el salario." },
        {
          texto:
            "Privar de las necesidades básicas (alimentación, salud, vestuario, etc.).",
        },
        { texto: "Cargar con deudas." },
        { texto: "Prohibir trabajar fuera." },
        {
          texto:
            "Limitar o impedir la administración o control de sus ingresos.",
        },
        { texto: "Negar el acceso a ingresos." },
        { texto: "Otras que pueden afectar la estabilidad económica." },
      ],
    },
    {
      titulo: "VIOLENCIA FEMINICIDA",
      texto:
        "Es la forma extrema de violencia de género contra las mujeres, producto de la violación de sus derechos humanos, en los ámbitos público y privado, conformada por el conjunto de conductas misóginas que conllevan a la impunidad social o del Estado, pudiendo culminar en feminicidio y en otras formas de muerte violenta de mujeres.",
      url_imagen: "/assets/images/violencia/Feminicida.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        { texto: "Muertes maternas prevenibles." },
        {
          texto:
            "Muertes violentas de mujeres en manos de sus parejas ej. ex-parejas, familiares o personas del entorno de confianza.",
        },
        {
          texto:
            "Muertes por desnutrición causada por la negación de acceso a recursos para alimentación.",
        },
        {
          texto:
            "Suicidios vinculados con embarazos no deseados en adolescentes.",
        },
        {
          texto:
            "Muerte de mujeres a manos de hombres extraños, ya sea de forma individual o bajo crimen organizado.",
        },
        { texto: "La desaparición de las mujeres." },
      ],
    },
    {
      titulo: "VIOLENCIA FÍSICA",
      texto:
        "Es toda conducta que directa o indirectamente, está dirigida a ocasionar daño o sufrimiento físico contra la mujer, con resultado o riesgo de producir lesión física o daño, ejercida por quien sea o haya sido su cónyuge o por quien esté o haya estado ligado a ella por análoga relación de afectividad, aun sin convivencia. Asimismo, tendrán la consideración de actos de violencia física contra la mujer, los ejercidos por la persona agresora en su entorno familiar, social o laboral.",
      url_imagen: "/assets/images/violencia/Fisica.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        { texto: "Golpes, patadas o puñetazos." },
        { texto: "Empujones, heridas o contusiones." },
        { texto: "Fracturas o hematonas." },
        { texto: "Discapacidad." },
        { texto: "Agresiones con armas de fuego." },
        { texto: "Quemaduras o pellizcos." },
      ],
    },
    {
      titulo: "VIOLENCIA PSICOLÓGICA",
      texto:
        "Es toda conducta directa o indirecta que ocasione daño emocional, disminuya el autoestima, perjudique o perturbe el sano desarrollo de la mujer; ya sea que esta conducta sea verbal, que produzca en la mujer desvalorización o sufrimiento, mediante amenazas, exigencia de obediencia o sumisión, coerción, culpabilización, así como daño reputacional a la imagen y dignidad de las mujeres en el entorno digital.",
      url_imagen: "/assets/images/violencia/Psicologica.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        { texto: "Gritos, insultos o apodos." },
        { texto: "Negar el afecto." },
        { texto: "Ignorar, manipular, chantajear o amenazar." },
        { texto: "Ofernder, humillar o exigir obediencia." },
        { texto: "Prohibición de salir." },
        { texto: "Hostigar" },
        { texto: "Controlar el arreglo personal." },
        { texto: "Perseguir." },
        { texto: "Prohibir tener amistades." },
        { texto: "Prohibir relacionarse con su familia" },
        { texto: "Prohibir estudiar." },
        { texto: "Amenazar con quitar hijos/as." },
        { texto: "Criticar el aspecto físico" },
        { texto: "Intimidar" },
      ],
    },
    {
      titulo: "VIOLENCIA PATRIMONIAL",
      texto:
        "Son las acciones, omisiones o conductas que afectan la libre disposición del patrimonio de la mujer; incluyéndose los daños a los bienes comunes o propios mediante la transformación, sustracción, destrucción, distracción, daño, perdida, limitación, retención de objetos, documentos personales, bienes, valores y derechos patrimoniales. En consecuente, serán nulos los actos de alzamiento, simulación de enajenación de los bienes muebles o inmuebles; cualquiera que sea el régimen patrimonial del matrimonio, incluyéndose el de la unión no patrimonial pudiendo ocurrir por medios digitales como mensajes.",
      url_imagen: "/assets/images/violencia/Patrimonial.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        {
          texto:
            "Apropiarse o destruir artículos u objetos de la mujer o del hogar.",
        },
        {
          texto:
            "Retención/destrucción de documentos personales u otros bienes.",
        },
        { texto: "Obligar a salir de la casa de habitación." },
        { texto: "Obligar a dar claves de cuentas bancarias." },
        { texto: "Estafas por medios digitales." },
      ],
    },
    {
      titulo: "VIOLENCIA SEXUAL",
      texto:
        "Es toda conducta que amenace o vulnere el derecho de la mujer a decidir voluntariamente su vida sexual, comprendida en esta no solo el acto sexual sino toda forma de contacto o acceso sexual, genital (incluyendo el chantaje o extorsión sexual por medios digitales) o no genital, con independencia de que las la persona agresora guarde o no relación conyugal, de pareja, social, laboral, efectiva o de parentesco con la mujer víctima.",
      url_imagen: "/assets/images/violencia/Sexual.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        {
          texto: "Tocamientos; contacto o acceso sexual, genital o no genital,",
        },
        { texto: "Acoso sexual." },
        { texto: "Violación." },
        { texto: "Exposición de genitales." },
        { texto: "Pornografía." },
        { texto: "Expresar palabras obscenas" },
        {
          texto: "Pedir imágenes de partes del cuerpo o desnudez por mensajes.",
        },
        { texto: "Introducir objetos," },
        { texto: "Obligar a ver pornografía." },
        { texto: "Obligar a presenciar actos sexuales." },
        { texto: "Obligar a tocamientos." },
        { texto: "Obligar a realizar actos sexuales con terceros." },
        { texto: "Obligar a mantener actos sexuales mientras está enferma." },
      ],
    },
    {
      titulo: "VIOLENCIA SIMBÓLICA",
      texto:
        "Son mensajes, valores, iconos o signos que transmiten y reproducen relaciones de dominación, desigualdad y discriminación en las relaciones sociales que se establecen entre las personas y naturalizan la subordinación de la mujer en la sociedad, pudiendo realizarse a través de medios digitales, por mensajes, redes sociales o sitios web.",
      url_imagen: "/assets/images/violencia/Simbolica.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        {
          texto:
            "Música, pintura, películas, novelas, que contienen mensajes de sumisión.",
        },
        { texto: "Celos o violencia." },
        {
          texto:
            "Publicidad con imágenes que cosifican a las mujeres y usan sus cuerpos para venta de productos.",
        },
        {
          texto:
            "Publicaciones de textos o imágenes en redes sociales y celulares que afectan la imagen de las mujeres.",
        },
        {
          texto:
            "Divulgar mensajes o imágenes íntimas que afectan la imagen de la mujer.",
        },
      ],
    },
    {
      titulo: "VIOLENCIA DIGITAL",
      texto:
        "Son todas las conductas de violencia contra las mujeres, cometida, facilitada, asistida o agravada en parte o en su totalidad a través del uso de tecnologías de la información y la comunicación, como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) o en entornos digitales como sitios web, plataformas, ya sea de forma organizada o no organizada por personas del entorno de confianza o no de las mujeres.",
      url_imagen: "/assets/images/violencia/Digital.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        {
          texto:
            "Que te pidan contraseña de tus cuentas de redes o correo electrónico.",
        },
        {
          texto: "Que te pidan enviar fotografías tuyas sin que tú lo quieras.",
        },
        {
          texto:
            "Que te insulten, amenacen o te desprestigien en redes sociales o chats grupales.",
        },
        {
          texto:
            "Que modifiquen tu imagen, tu voz o entorno sin tu consentimiento.",
        },
        {
          texto:
            "Que te coloquen dispositivos o aplicaciones que identifiquen tu ubicación o expongan tus datos.",
        },
      ],
    },
    {
      titulo: "VIOLENCIA POLÍTICA",
      texto:
        "Acciones u omisiones contra las mujeres, realizadas de forma directa o indirecta por razón de género, que causen daño individual o colectivo y que tienen por objeto menoscabar o anular el reconocimiento, goce o ejercicio de sus derechos políticos y civiles, en cualquier ámbito de la vida política. Los ámbitos de la vida política comprenden el ejercicio de los derechos políticos, tales como derecho de organización, participación en procesos electorales y en órganos de dirección, así como la participación en el desarrollo rural y urbano.",
      url_imagen: "/assets/images/violencia/Politica.png",
      modalidades: [
        {
          titulo: "Violencia Comunitaria",
          texto:
            "Toda acción u omisión abusiva que a partir de actos individuales o colectivos transgreden los derechos fundamentales de la mujer y propician su degradación, discriminación, marginación o exclusión y ocurren en la comunidad, colonia, espacios colectivos como las Adesco, Sindicato, Junta directiva vecinal u otras.",
          url_icono: "violenciaComunitaria.png",
        },
        {
          titulo: "Violencia Institucional",
          texto:
            "Es toda acción u omisión abusiva de cualquier servidor público, que discrimine o tenga como fin dilatar, obstaculizar o impedir el goce y disfrute de los derechos y libertades fundamentales de las mujeres así como, la que pretenda obstaculizar u obstaculice el acceso de las mujeres al disfrute de políticas públicas destinadas a prevenir, atender, investigar, sancionar y erradicar las manifestaciones, tipos y modalidades de violencia conceptualizadas en esta ley y puede ocurrir en oficinas públicas como alcaldías, ministerios o servicios como los de salud.",
          url_icono: "violenciaInstitucional.png",
        },
        {
          titulo: "Violencia Laboral",
          texto:
            "Son acciones u omisiones contra las mujeres ejercidas en forma repetida y que se mantiene en el tiempo en los centros de trabajo público o privados, que constituyan agresiones físicas o psicológicas atentatorias a su integridad, dignidad personal y profesional, que obstaculicen su acceso al empleo, ascenso o estabilidad en el mismo, o que quebranten el derecho a igual salario por igual trabajo.",
          url_icono: "violenciaLaboral.png",
        },
        {
          titulo: "Violencia Familiar",
          texto:
            "Es cualquier acción u omisión, directa o indirecta que cause daño, sufrimiento físico, sexual o muerte a las mujeres en el marco de las relaciones de familia como cónyuges, excónyuges, convivientes, exconvivientes, ascendientes, descendientes, parientes, colaterales por consanguinidad, afinidad, adopción, los de sujetos a tutela o guarda, incluso las relaciones interpersonales como las del noviazgo.",
          url_icono: "violenciaFamiliar.png",
        },
        {
          titulo: "Violencia Digital",
          texto:
            "Es toda conducta contra las mujeres que sea cometida, asistida o agravada en parte o en su totalidad por el uso de las tecnologías de la información y la comunicación (TIC), como teléfonos móviles y teléfonos inteligentes, Internet, plataformas de redes sociales o correo electrónico, dispositivos de seguimiento de geolocalización, drones y dispositivos de grabación no conectados a Internet e Inteligencia Artificial (IA) y ocurre en la dimensión digital, pudiendo afectar cualquier derecho de las mujeres.",
          url_icono: "violenciaDigital.png",
        },
      ],
      ejemplos: [
        {
          texto:
            "Ataques y descalificaciones a mujeres que participan en la política con campañas de desprestigio por su género en lugar de por su desempeño.",
        },
        {
          texto:
            "Exclusión de espacios de decisión, las mujeres son relegadas a posiciones simbólicas o no se les permite ocupar cargos claves dentro de sus partidos.",
        },
        {
          texto:
            "Ataques sexistas, amenazas y comentarios misóginos que buscan desincentivar su participación en la política.",
        },
        {
          texto:
            "Se subestima sus capacidades políticas por ser mujeres para limitar su participación y liderazgo.",
        },
        {
          texto:
            "Estigmatización por su entorno social, que afecta su vida personal y profesional.",
        },
        {
          texto:
            "Ataques digitales para desprestigiar su imagen y credibilidad.",
        },
      ],
    },
  ],
  servicios_de_atencion: [
    {
      titulo: "SALUD",
      logo: "/assets/images/servicios/salud.png",
      items: [
        {
          id: 37,
          title: "UIAEM San Salvador",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22319539,
          direcction:
            "Centro de Gobierno, 9ª calle Poniente nivel 1, torre PGR",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/og3o6eNNBBPeYpXj8",
          coordinate: {
            latitude: 13.704617499812654,
            longitude: -89.19731219835788,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 38,
          title: "UIAEM Soyapango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22458928,
          direcction:
            "Barrio El Progreso, Avenida Las Palmeras, Pasaje Morazán No. 3, Soyapango, San Salvador",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/qCgfok7C2WPpHQxc6",
          coordinate: {
            latitude: 13.705388080903026,
            longitude: -89.1546917646495,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 39,
          title: "UIAEM Sonsonate",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014128,
          direcction:
            "Colonia San Francisco, 4ª Calle Oriente, No. 22, Sonzacate, Sonsonate",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/zFGUrXBm2WgLGmkj9",
          coordinate: {
            latitude: 13.728183225115007,
            longitude: -89.71415903230243,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 40,
          title: "UIAEM Santa Ana",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014110,
          direcction:
            "Avenida Fray Felipe de Jesús Moraga Sur entre 2º y 6º Calle Poniente No.6, Santa Ana",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/h2ruMy7CRPyGhRGQ9",
          coordinate: {
            latitude: 13.99663018881077,
            longitude: -89.56335348858265,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 41,
          title: "UIAEM La Libertad",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22458911,
          direcction:
            "6ª Calle Oriente y Av. Dr. José Zablah Touche, casa No. 5-6 San Tecla La Libertad Colonia Útila",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/mJTUapGwR5Ermws7A",
          coordinate: {
            latitude: 13.671417033166552,
            longitude: -89.28131886118665,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 42,
          title: "UIAM Ahuachapán",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014144,
          direcction: "3a Calle Poniente No. 2-2 Barrio San José, Ahuachapán",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/1pjGG4qJ2XRrn3F97",
          coordinate: {
            latitude: 13.921006803815587,
            longitude: -89.84761205855072,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 43,
          title: "UIAEM Cuscatlán",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25277443,
          direcction:
            "6ª Calle Oriente, Barrio San Juan, calle a La Estación, casa No. 15, Cojutepeque, Cuscatlán",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/RwKFkxQTfda6BuVc6",
          coordinate: {
            latitude: 13.718794907270578,
            longitude: -88.93143760006161,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 44,
          title: "UIAEM La Paz",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014172,
          direcction:
            "Calle Dr. Nicolás Peña No. 27, Barrio Candelaria, Zacatecoluca, La Paz",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/MNAvjqodtXeo1Ht99",
          coordinate: {
            latitude: 13.50742122841332,
            longitude: -88.86754931700938,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 45,
          title: "UIAEM Chalatenango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014158,
          direcction:
            "Lotificación Santa Emilia kilómetro 77, Caserío Totolco, Chalatenango",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/PutkxZ1SPdXbPdtG8",
          coordinate: {
            latitude: 14.040879095974097,
            longitude: -88.95816262667044,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 51,
          title: "CEM. LOURDES COLON",
          time: "24/7",
          phone: 25650800,
          direcction:
            "Carretera de Lourdes Colón hacia Sonsonate, entrada a la 600, Cantón Entre Ríos, Colón Dpto. La Libertad",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/N7yzfHPgqLLAGHte7",
          coordinate: {
            latitude: 13.735690507193581,
            longitude: -89.3587405,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 52,
          title: "CEM. SAN MARTIN",
          time: "24/7",
          phone: 25551400,
          direcction:
            "Carretera de Oro, Finca Gran Bretaña, contiguo a Parque El Recreo, San Martín, Dpto. San Salvador",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/PDRLeBhow7HLYueZA",
          coordinate: {
            latitude: 13.733922879256452,
            longitude: -89.06781745099842,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 53,
          title: "CEM. USULUTAN",
          time: "24/7",
          phone: 26091200,
          direcction:
            "9° Calle Oriente y final 8° Avenida Sur, Barrio El Calvario frente a Centro de Gobierno, Depto. de Usulután",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/BC6wNmnFdHpCQhHb7",
          coordinate: {
            latitude: 13.340194014512731,
            longitude: -88.43681609666889,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 54,
          title: "CEM. SAN MIGUEL",
          time: "24/7",
          phone: 26092000,
          direcction:
            "15 Calle Oriente, entre 8° y 10° Avenida Sur, Ex Fenadesal, Colonia Los Angeles, Dpto. de San Miguel",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/ZWKrcUyhyFB1Say39",
          coordinate: {
            latitude: 13.472595873462891,
            longitude: -88.17105326350742,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 55,
          title: "CEM. MORAZAN",
          time: "24/7",
          phone: 26096429,
          direcction:
            "Carretera Ruta Militar, Cantón Llano de Santiago, El Divisadero, Dpto. de Morazán",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/fHFuZ9Ct8j1PEHCz9",
          coordinate: {
            latitude: 13.587175574695133,
            longitude: -88.0759766582853,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 56,
          title: "CEM. SANTA ANA",
          time: "24/7",
          phone: 24042500,
          direcction:
            "Km 61.½ Carretera Panamericana, Finca Santa Teresa, Cantón Chupadero, Dpto. Santa Ana",
          Icon: "CEM.jpg",
          mapURL: "https://maps.app.goo.gl/wG9dq48dhLnsKwzK9",
          coordinate: {
            latitude: 13.957491867511607,
            longitude: -89.58033804028885,
          },
          tiposAtencion: `Salud`,
        },
      ],
    },
    {
      titulo: "ATENCIÓN LEGAL",
      logo: "/assets/images/servicios/atencionLegal.png",
      items: [
        {
          id: 37,
          title: "UIAEM San Salvador",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22319539,
          direcction:
            "Centro de Gobierno, 9ª calle Poniente nivel 1, torre PGR",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/og3o6eNNBBPeYpXj8",
          coordinate: {
            latitude: 13.704617499812654,
            longitude: -89.19731219835788,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 38,
          title: "UIAEM Soyapango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22458928,
          direcction:
            "Barrio El Progreso, Avenida Las Palmeras, Pasaje Morazán No. 3, Soyapango, San Salvador",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/qCgfok7C2WPpHQxc6",
          coordinate: {
            latitude: 13.705388080903026,
            longitude: -89.1546917646495,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 39,
          title: "UIAEM Sonsonate",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014128,
          direcction:
            "Colonia San Francisco, 4ª Calle Oriente, No. 22, Sonzacate, Sonsonate",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/zFGUrXBm2WgLGmkj9",
          coordinate: {
            latitude: 13.728183225115007,
            longitude: -89.71415903230243,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 40,
          title: "UIAEM Santa Ana",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014110,
          direcction:
            "Avenida Fray Felipe de Jesús Moraga Sur entre 2º y 6º Calle Poniente No.6, Santa Ana",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/h2ruMy7CRPyGhRGQ9",
          coordinate: {
            latitude: 13.99663018881077,
            longitude: -89.56335348858265,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 41,
          title: "UIAEM La Libertad",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22458911,
          direcction:
            "6ª Calle Oriente y Av. Dr. José Zablah Touche, casa No. 5-6 San Tecla La Libertad Colonia Útila",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/mJTUapGwR5Ermws7A",
          coordinate: {
            latitude: 13.671417033166552,
            longitude: -89.28131886118665,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 42,
          title: "UIAM Ahuachapán",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014144,
          direcction: "3a Calle Poniente No. 2-2 Barrio San José, Ahuachapán",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/1pjGG4qJ2XRrn3F97",
          coordinate: {
            latitude: 13.921006803815587,
            longitude: -89.84761205855072,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 43,
          title: "UIAEM Cuscatlán",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25277443,
          direcction:
            "6ª Calle Oriente, Barrio San Juan, calle a La Estación, casa No. 15, Cojutepeque, Cuscatlán",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/RwKFkxQTfda6BuVc6",
          coordinate: {
            latitude: 13.718794907270578,
            longitude: -88.93143760006161,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 44,
          title: "UIAEM La Paz",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014172,
          direcction:
            "Calle Dr. Nicolás Peña No. 27, Barrio Candelaria, Zacatecoluca, La Paz",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/MNAvjqodtXeo1Ht99",
          coordinate: {
            latitude: 13.50742122841332,
            longitude: -88.86754931700938,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 45,
          title: "UIAEM Chalatenango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22014158,
          direcction:
            "Lotificación Santa Emilia kilómetro 77, Caserío Totolco, Chalatenango",
          Icon: "PGR.jpg",
          mapURL: "https://maps.app.goo.gl/PutkxZ1SPdXbPdtG8",
          coordinate: {
            latitude: 14.040879095974097,
            longitude: -88.95816262667044,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 46,
          title: "SAIV-Centro Judicial Dr. Isidro Menéndez, San Salvador",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22358600,
          direcction:
            "Bulevar Tutunichapa, edificio C, primera planta, San Salvador Centro",
          Icon: "CSJ.jpg",
          mapURL: "https://maps.app.goo.gl/sHoYeigEtEuQqF3z5",
          coordinate: {
            latitude: 13.708628661622718,
            longitude: -89.19915223068635,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 47,
          title: "SAIV-Centro Judicial de Soyapango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22979100,
          direcction:
            "Cantón y calle Matazano, Pasaje Marsella, Soyapango, San Salvador Este",
          Icon: "CSJ.jpg",
          mapURL: "https://maps.app.goo.gl/HPWNvo5BR9UuS38b7",
          coordinate: {
            latitude: 13.69060054687019,
            longitude: -89.1377046746791,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 48,
          title: "SAIV-Centro Judicial de Ciudad Delgado",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25279800,
          direcction: "Avenida Juan Bertis, No. 75. CD, San Salvador Centro",
          Icon: "CSJ.jpg",
          mapURL: "https://maps.app.goo.gl/rRG4XcrVkabwDwpq6",
          coordinate: {
            latitude: 13.714327245879495,
            longitude: -89.1702701035147,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 49,
          title: "SAIV-Chalatenango",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 23012352,
          direcction:
            "Calle San Martin No. 19, Barrio Las Flores, Chalatenango",
          Icon: "CSJ.jpg",
          mapURL: "https://maps.app.goo.gl/P3ZYhDNULfVWzVCt8",
          coordinate: {
            latitude: 14.041031123353587,
            longitude: -88.94030645112805,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 50,
          title: "SAIV-San Miguel",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 26600688,
          direcction:
            'Colonia Hirleman, pasaje "A", block 4, casa #1, San Miguel',
          Icon: "CSJ.jpg",
          mapURL: "https://maps.app.goo.gl/X7xeZSftZFU2C3wS6",
          coordinate: {
            latitude: 13.487659187381686,
            longitude: -88.18975255102059,
          },
          tiposAtencion: `Atención Legal`,
        },
        {
          id: 57,
          title: "LAS DIGNAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25295800,
          direcction:
            "Avenida Bernal, #16-S. Colonia Satélite, San Salvador, El Salvador",
          Icon: "DIGNAS.jpg",
          mapURL: "https://maps.app.goo.gl/sPwkmoTGb5275z6o9",
          coordinate: {
            latitude: 13.722052893772947,
            longitude: -89.21669034962983,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 58,
          title: "LAS MÉLIDAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22252511,
          direcction:
            "23 Calle Poniente, Calle y Avenida Victorias No 123, Urb. Palomo, Mejicanos, El Salvador",
          Icon: "MELIDAS.jpg",
          mapURL: "https://maps.app.goo.gl/aGpKwBK3Pk56Lgez6",
          coordinate: {
            latitude: 13.710966702643143,
            longitude: -89.20079874778258,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 59,
          title: "ORMUSA",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25560032,
          direcction:
            "7ª calle poniente bis #5265, colonia Escalón. San Salvador, El Salvador",
          Icon: "MELIDAS.jpg",
          mapURL: "https://maps.app.goo.gl/uAJFzAjHBNi1URtJ8",
          coordinate: {
            latitude: 13.709205480860911,
            longitude: -89.24967909011193,
          },
          tiposAtencion: `Salud`,
        },
      ],
    },
    {
      titulo: "ATENCIÓN EMOCIONAL",
      logo: "/assets/images/servicios/atencionEmocional.png",
      items: [
        {
          id: 57,
          title: "LAS DIGNAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25295800,
          direcction:
            "Avenida Bernal, #16-S. Colonia Satélite, San Salvador, El Salvador",
          Icon: "DIGNAS.jpg",
          mapURL: "https://maps.app.goo.gl/sPwkmoTGb5275z6o9",
          coordinate: {
            latitude: 13.722052893772947,
            longitude: -89.21669034962983,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 58,
          title: "LAS MÉLIDAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22252511,
          direcction:
            "23 Calle Poniente, Calle y Avenida Victorias No 123, Urb. Palomo, Mejicanos, El Salvador",
          Icon: "MELIDAS.jpg",
          mapURL: "https://maps.app.goo.gl/aGpKwBK3Pk56Lgez6",
          coordinate: {
            latitude: 13.710966702643143,
            longitude: -89.20079874778258,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 59,
          title: "ORMUSA",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25560032,
          direcction:
            "7ª calle poniente bis #5265, colonia Escalón. San Salvador, El Salvador",
          Icon: "MELIDAS.jpg",
          mapURL: "https://maps.app.goo.gl/uAJFzAjHBNi1URtJ8",
          coordinate: {
            latitude: 13.709205480860911,
            longitude: -89.24967909011193,
          },
          tiposAtencion: `Salud`,
        },
      ],
    },
    {
      titulo: "ATENCIÓN POLICIAL",
      logo: "/assets/images/servicios/atencionPolicial.png",
      items: [
        {
          id: 1,
          title: "UNIMUJER SAN SALVADOR CENTRO",
          time: "24/7",
          phone: "2529-1426 / 2529-1427",
          direcction:
            "7a. Av. Nte. Entre Alameda Juan Pablo II y 5a Calle Pte.# 418, frente al parque infantil, San Salvador.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/QSFAxYFBshSeSkwf7",
          coordinate: {
            latitude: 13.702771369396112,
            longitude: -89.19446136382496,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 2,
          title: "UNIMUJER APOPA",
          time: "24/7",
          phone: 22417904,
          direcction:
            "Col. Madre Tierra 1, Calle Ppal. #2, Contiguo a Instituto Nacional INA, Apopa, San Salvador",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/Tugew9jTwXmTsQQp9",
          coordinate: {
            latitude: 13.672052167609126,
            longitude: -89.28459662562331,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 3,
          title: "UNIMUJER SOYAPANGO",
          time: "24/7",
          phone: 25291640,
          direcction:
            "Boulevard San Bartolo, Ilopango, frente a INSAFORP y zona franca, Ilopango",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/ibr6vJufJc66wSuy7",
          coordinate: {
            latitude: 13.70064454956582,
            longitude: -89.10484817674235,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 4,
          title: "UNIMUJER SAN SALVADOR DCI",
          time: "24/7",
          phone: 25111114,
          direcction:
            "Col. El Rosal, Calle El Progreso, Edificio 2810, frente a ex CENADE, San Salvador",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/qXez8o7ULoAFSGPm7",
          coordinate: {
            latitude: 13.69713184932305,
            longitude: -89.2197350330792,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 5,
          title: "UNIMUJER SAN MARCOS",
          time: "24/7",
          phone: 22207807,
          direcction:
            "Carretera Antigua a Zacatecoluca, Km. 5.5 , Calle 25 de Abril Ote., Barrio El Centro, San Marcos.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/WNUZqpbU1MG5xFcB7",
          coordinate: {
            latitude: 13.657141943381879,
            longitude: -89.18210743988054,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 6,
          title: "UNIMUJER AGUILARES",
          time: "24/7",
          phone: 23214011,
          direcction:
            "8a. Calle Poniente y 5a. Av. Norte, casa sin #, Barrio Guadalupé,(punto de referencia contiguo a delegación policial) Aguilares, San Salvador.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/YCWLr6v1nyPSjWow9",
          coordinate: {
            latitude: 13.973504358410763,
            longitude: -89.21769988749544,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 7,
          title: "UNIMUJER CIUDAD DELGADO",
          time: "24/7",
          phone: 22769536,
          direcction:
            "Carretera Troncal del Norte, Km. 4 1/2, Col. Bolívar, Calle Ppal.# 51 Ciudad Delgado, San Salvador.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/UwFGXocLjLwNQ2w79",
          coordinate: {
            latitude: 13.71256905260615,
            longitude: -89.17168279325371,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 8,
          title: "UNIMUJER CIUDAD ARCE",
          time: "24/7",
          phone: 23309322,
          direcction:
            "3a. Av. Nte. N° 2B, Costado Ote. Del parque central , Ciudad Arce, La Libertad.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/taaky4trQegtuuz96",
          coordinate: {
            latitude: 13.842256616410651,
            longitude: -89.44601451802257,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 9,
          title: "UNIMUJER MEJICANOS",
          time: "24/7",
          phone: 70742288,
          direcction:
            "Final 5a. Ave. Nte. Y 2a Calle Pte, por el pasaje San Juan, (punto de referencia frente a super selectos) Mejicanos",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/vouZzPKdf1uvkQp39",
          coordinate: {
            latitude: 13.722237410709443,
            longitude: -89.19052579507601,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 10,
          title: "UNIMUJER SAN JUAN OPICO",
          time: "24/7",
          phone: 23473418,
          direcction:
            "2a. Calle Oriente y 4a Av. Norte, Barrio el Centro (punto de referencia contiguo a agencia DELSUR) San Juan Opico",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/zLNtTrbDs2nfjvZt6",
          coordinate: {
            latitude: 13.875931864929589,
            longitude: -89.35823927116421,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 11,
          title: "UNIMUJER SANTA TECLA",
          time: "24/7",
          phone: 22287998,
          direcction:
            "4a. Calle Ote. Y Av. Melvin Jones #2-7, Santa Tecla, La Libertad.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/MCreUoQVN1C1wTJy5",
          coordinate: {
            latitude: 13.672136727236754,
            longitude: -89.28459768895524,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 12,
          title: "UNIMUJER ODAC LA LIBERTAD",
          time: "24/7",
          phone: 23277932,
          direcction:
            "Carretera El Litoral, km 34.5 frente a Malecón Turístico, Puerto de la Libertad.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/TuRowRt2CqX4iqis8",
          coordinate: {
            latitude: 13.487438706449474,
            longitude: -89.32030193988055,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 13,
          title: "UNIMUJER ZARAGOZA",
          time: "24/7",
          phone: 23140481,
          direcction:
            "Ave. Monseñor Oscar Arnulfo Romero, Barrios El Centro, Casa N° 16, Zaragoza",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/8sHnUmq6KRsEMqSWA",
          coordinate: {
            latitude: 13.587951896058748,
            longitude: -89.2873016071152,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 14,
          title: "UNIMUJER CHALATENANGO",
          time: "24/7",
          phone: 23012352,
          direcction:
            "Final Calle San Martín, No.19 Costado sur de Alcaldía municipal de Chalatenango, (punto de referencia frente a oficinas de Claro), Chalatenango.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/ysxZzioJDVL7bo3C6",
          coordinate: {
            latitude: 14.042579712550413,
            longitude: -88.93531062506318,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 15,
          title: "UNIMUJER CARA SUCIA",
          time: "24/7",
          phone: 24370836,
          direcction:
            "6a. Calle Ote Bo. San Martín, Canton Cara Sucia San Francisco Menéndez, Ahuachapán.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/r6MP6vdn7Vgsoa6D8",
          coordinate: {
            latitude: 13.77886154728178,
            longitude: -90.03285439447761,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 16,
          title: "UNIMUJER ACAJUTLA",
          time: "24/7",
          phone: 24523857,
          direcction:
            "Boulevard Coronel Oscar Osorio, contiguo a redondel CEPA, Acajutla, Sonsonate",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/pT1FQo3nHEVq181z5",
          coordinate: {
            latitude: 13.585316968335329,
            longitude: -89.83037369605553,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 17,
          title: "UNIMUJER CHALCHUAPA",
          time: "24/7",
          phone: 24085065,
          direcction:
            "11 Avenida Sur ENTRE 1a y 3a. Calle Ote, Barrios Apaneca, Chalchuapa",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/Ji4xyUVwFY43Xk8i8",
          coordinate: {
            latitude: 13.982562998386966,
            longitude: -89.67366977139082,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 18,
          title: "UNIMUJER SANTA ANA",
          time: "24/7",
          phone: 24208666,
          direcction:
            "25 Calle Pte. Entre 14 y 16 Av. Sur, edificio Mario Calvo, (punto de referencia sobre semáforo la 25 Calle) Santa Ana.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/euPwf3MP1u1CmTv8A",
          coordinate: {
            latitude: 13.984082350249581,
            longitude: -89.56542087745237,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 19,
          title: "UNIMUJER AHUACHAPAN",
          time: "24/7",
          phone: 24208406,
          direcction:
            "Av. Morazán Frente a Colonia IVU a 50 metros de los Bomberos, Ahuachapán.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/ct6tKsZYsovBTah49",
          coordinate: {
            latitude: 13.927603264117025,
            longitude: -89.85158409371932,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 20,
          title: "UNIMUJER METAPAN",
          time: "24/7",
          phone: 24022857,
          direcction:
            "Carretera que de Santa Ana conduce a Metapán Km 110, frente Hospital Nacional Arturo Morales, Metapán, Santa Ana",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/kbN2jJMsp6ihWyZ18",
          coordinate: {
            latitude: 14.325117141021499,
            longitude: -89.44378147932508,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 21,
          title: "UNIMUJER IZALCO",
          time: "24/7",
          phone: 24535364,
          direcction:
            "Barrio San Sebastian, 1° Calle Oriente entre Avenida Morazán y 2° Avenida Sur, Izalco.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/kVuKYZWJLVE8qVmXA",
          coordinate: {
            latitude: 13.747058341159494,
            longitude: -89.67412661838837,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 22,
          title: "UNIMUJER SONSONATE",
          time: "24/7",
          phone: 70707126,
          direcction:
            "Boulevard Coronel Oscar Osorio, Carretera Hacia Acajutla, Kilómetro 76 1/2, (punto de referencia contiguo a cuerpo de bomberos), Sonsonate.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/UfrWwWVZXKbLk8KN6",
          coordinate: {
            latitude: 13.714824141501747,
            longitude: -89.72553502023892,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 23,
          title: "UNIMUJER CONCHAGUA",
          time: "24/7",
          phone: 26803470,
          direcction:
            "Calle 15 de septiembre, contiguo a pasaje El Tamarindo, Barrio la Cruz, (punto de referencia una cuadra al sur de la Alcaldía Municipal) Conchagua, La Unión",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/mbdSGESu7baH9oqM9",
          coordinate: {
            latitude: 13.305653042108139,
            longitude: -87.8624509358139,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 24,
          title: "UNIMUJER LA UNIÓN",
          time: "24/7",
          phone: 26222864,
          direcction:
            "1A. Ave. Nte. y 7a Calle Pte., Centro de Gobierno, Barrio El Centro, (punto de referencia contiguo a correos) La Unión",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/4uXPKfmUqh7oMohV7",
          coordinate: {
            latitude: 13.340810866284352,
            longitude: -87.8463815579034,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 25,
          title: "SUB DELEGACIÓN JIQUILISCO",
          time: "24/7",
          phone: 26638816,
          direcction:
            "1a. Calle Pte. Bo. San José, # 10, Barrio San Antonio, (punto de referencia a una cuadra bajo del Banco Agrícola) Jiquilisco, Usulután",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/LxRMuqX7Ume82iebA",
          coordinate: {
            latitude: 13.328342921118603,
            longitude: -88.57125091578696,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 26,
          title: "UNIMUJER SANTA ROSA DE LIMA",
          time: "24/7",
          phone: 26412129,
          direcction:
            "Carretera Ruta Militar, Colonia Altos del Estadio, Costado Oriente del Estadio Municipal, Santa Rosa de Lima, La Unión",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/ZemDsUEehRN4hQaBA",
          coordinate: {
            latitude: 13.631452060802824,
            longitude: -87.88882697678974,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 27,
          title: "UNIMUJER SAN MIGUEL",
          time: "24/7",
          phone: 26222701,
          direcction:
            "Colonia Belem, 10a Ave. Sur y 9a. Calle Ote, Centro de Gobierno, San Miguel",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/te5CA3TMcYMbFPUU6",
          coordinate: {
            latitude: 13.475543920494825,
            longitude: -88.170429090619,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 28,
          title: "UNIMUJER COJUNTEPEQUE, CUSCATLÁN",
          time: "24/7",
          phone: 23277618,
          direcction:
            "7a. Av. Sur, Barrio San Nicolás, Ex - Instituto Cultural, (punto de referencia Monumento a la Madre) Cojutepeque, Cuscatlán",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/7LfQD6Gt3tFYD7dt6",
          coordinate: {
            latitude: 13.721382384077987,
            longitude: -88.9388702358137,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 29,
          title: "UNIMUJER SUCHITOTO",
          time: "24/7",
          phone: 23351141,
          direcction:
            "4a. Av. Norte y 2a. Calle Oriente. Local Ex -Museo de la Moneda, Barrio San José, Suchitoto, Cuscatlán",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/KpoLXSLkVcqDgG5i7",
          coordinate: {
            latitude: 13.938395103469004,
            longitude: -89.02754827925972,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 30,
          title: "UNIMUJER SENSUNTEPEQUE, CABAÑAS",
          time: "24/7",
          phone: 23822219,
          direcction:
            "Final Av. Libertad, Barrio San Antonio, contiguo Terminal de buses Sensuntepeque, Cabañas.",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/XWwWYoDgtqNcpM8DA",
          coordinate: {
            latitude: 13.877943738425433,
            longitude: -88.62715313030712,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 31,
          title: "UNIMUJER EL PEDREGAL",
          time: "24/7",
          phone: 23556570,
          direcction:
            "Intersección de la Carretera El Litoral y calle a la Herradura, cacerío Los Arcos, Cantón el Pedregal, Rosario de la Paz, La Paz",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/mJKDeyZJrsPVdeGw7",
          coordinate: {
            latitude: 13.463603385820823,
            longitude: -89.00967501204435,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 32,
          title: "UNIMUJER SAN VICENTE",
          time: "24/7",
          phone: 23936747,
          direcction:
            "Barrio San Francisco 6a. Av. Nte y 4a Calle Ote, # 27, (punto de referencia atrás del hospital Nacional Santa Getrudis) San Vicente",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/BuYz8h4drFiCJt1DA",
          coordinate: {
            latitude: 13.641133799418721,
            longitude: -88.78380168703244,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 33,
          title: "UNIMUJER LA NUEVA CONCEPCIÓN",
          time: "24/7",
          phone: 23357031,
          direcction:
            "4° Calle Poniente y 5° Av. Sur, Barrio El Carmen, Nueva Concepción, Chalatenango",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/hSU5PhHXX1Hpo6R2A",
          coordinate: {
            latitude: 14.127061672706086,
            longitude: -89.29392793384068,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 34,
          title: "UNIMUJER ZACATECOLUCA",
          time: "24/7",
          phone: 23488300,
          direcction:
            "Kilómetro 58, Cantón Platanares, Carretera del Litoral hacia Usulután, (punto de referencia redondel de penal de máxima seguridad) Zacatecoluca, La Paz",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/nR7WxMUWwx6aN33e8",
          coordinate: {
            latitude: 13.497800603702435,
            longitude: -88.8629785423284,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 35,
          title: "UNIMUJER MORAZAN",
          time: "24/7",
          phone: 26542132,
          direcction:
            "Final 1a calle Pte y 3a Nte. Barrio El Centro, contiguo a Banco Davivienda, San Francisco Gotera",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/gkG1u11T78qaphYF7",
          coordinate: {
            latitude: 13.697069811650431,
            longitude: -88.10641942748961,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
        {
          id: 36,
          title: "UNIMUJER ILOBASCO",
          time: "24/7",
          phone: 23322871,
          direcction:
            "4a Avenida Nte. Barrio San Miguel, (punto de referencia contiguo a Liceo Cristiano) Ilobasco, Cabañas",
          Icon: "PNC.jpg",
          mapURL: "https://maps.app.goo.gl/TVReNmMZxYv7EKh66",
          coordinate: {
            latitude: 13.845176941832252,
            longitude: -88.84891358502571,
          },
          tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
        },
      ],
    },
    {
      titulo: "GRUPOS DE APOYO",
      logo: "/assets/images/servicios/gruposdeApoyo.png",
      items: [
        {
          id: 57,
          title: "LAS DIGNAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25295800,
          direcction:
            "Avenida Bernal, #16-S. Colonia Satélite, San Salvador, El Salvador",
          Icon: "DIGNAS.jpg",
          mapURL: "https://maps.app.goo.gl/sPwkmoTGb5275z6o9",
          coordinate: {
            latitude: 13.722052893772947,
            longitude: -89.21669034962983,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 58,
          title: "LAS MÉLIDAS",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 22252511,
          direcction:
            "23 Calle Poniente, Calle y Avenida Victorias No 123, Urb. Palomo, Mejicanos, El Salvador",
          Icon: "MELIDAS.jpg",
          mapURL: "https://maps.app.goo.gl/aGpKwBK3Pk56Lgez6",
          coordinate: {
            latitude: 13.710966702643143,
            longitude: -89.20079874778258,
          },
          tiposAtencion: `Salud`,
        },
        {
          id: 59,
          title: "ORMUSA",
          time: "8:00AM - 4:00PM LUN-VIER",
          phone: 25560032,
          direcction:
            "7ª calle poniente bis #5265, colonia Escalón. San Salvador, El Salvador",
          Icon: "ISDEMU.jpg",
          mapURL: "https://maps.app.goo.gl/uAJFzAjHBNi1URtJ8",
          coordinate: {
            latitude: 13.709205480860911,
            longitude: -89.24967909011193,
          },
          tiposAtencion: `Salud`,
        },
      ],
    },
  ],
  leyes_y_decretos: [
    {
      titulo: "CÓDIGO PENAL",
      url_audio: "",
      url_pdf: "/pdf/CODIGO PENAL 26-04-1998.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CÓDIGO PROCESAL PENAL",
      url_audio: "",
      url_pdf: "/pdf/CODIGO PROCESAL PENAL 2011.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONSTITUCIÓN DE LA REPÚBLICA DE EL SALVADOR",
      url_audio: "",
      url_pdf: "/pdf/CONSTITUCIÓN 1983.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONVENCION AMERICANA DE DERECHOS HUMANOS PACTO DE SAN JOSE",
      url_audio: "",
      url_pdf:
        "/pdf/CONVENCION AMERICANA DE DERECHOS HUMANOS PACTO DE SAN JOSE 22-11-1969.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONVENCION BELEM DO PARA 1994",
      url_audio: "",
      url_pdf: "/pdf/CONVENCION BELEM DO PARA 1994.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONVENCION CEDAW 1979",
      url_audio: "",
      url_pdf: "/pdf/CONVENCION CEDAW 1979.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONVENCION DE LOS DERECHOS DEL NIÑO 1989",
      url_audio: "",
      url_pdf: "/pdf/CONVENCION DE LOS DERECHOS DEL NIÑO 1989.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CONVENIO 190 OIT SOBRE LA VIOLENCIA Y EL ACOSO 2019",
      url_audio: "",
      url_pdf:
        "/pdf/Convenio 190 OIT sobre la violencia y el acoso 21-06-2019.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "CÓDIGO DE FAMILIA",
      url_audio: "",
      url_pdf: "/pdf/DL CODIGO DE FAMILIA 11-10-93.pdf",
      url_codigo_componente: "LeyOne",
    },

    {
      titulo: "LEY CONTRA LA VIOLENCIA INTRAFAMILIAR",
      url_audio: "",
      url_pdf: "/pdf/DL LEY CONTRA LA VIOLENCIA INTRAFAMILIAR 28-11-96.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo:
        "LEY CRECER JUNTOS PARA PROTECCION INTEGRAL DE LA PRIMERA INFANCIA NIÑEZ Y ADOLESCENCIA",
      url_audio: "",
      url_pdf:
        "/pdf/DL LEY CRECER JUNTOS PARA PROTECCION INTEGRAL DE LA PRIMERA INFANCIA NIÑEZ Y ADOLESCENCIA 22-06-2022.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo:
        "LEY DE IGUALDAD EQUIDAD Y ERRADICACIÓN DE LA DISCRIMINACIÓN CONTRA LAS MUJERES",
      url_audio: "",
      url_pdf:
        "/pdf/DL LEY DE IGUALDAD EQUIDAD Y ERRADICACIÓN DE LA DISCRIMINACIÓN CONTRA LAS MUJERES 08-04-2011 CON REFORMAS.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo:
        "LEY ESPECIAL INTEGRAL PARA UNA VIDA LIBRE DE VIOLENCIA PARA LAS MUJERES",
      url_audio: "",
      url_pdf:
        "/pdf/DL LEY ESPECIAL INTEGRAL PARA UNA VIDA LIBRE DE VIOLENCIA PARA LAS MUJERES 25-07-2022 CON TODAS REFORMAS.pdf",
      url_codigo_componente: "LeyOne",
    },
    {
      titulo: "LEY GENERAL DE PREVENCION DE RIESGOS EN LOS LUGARES DE TRABAJO",
      url_audio: "",
      url_pdf:
        "/pdf/DL LEY GENERAL DE PREVENCION DE RIESGOS EN LOS LUGARES DE TRABAJO 10-04-10.pdf",
      url_codigo_componente: "LeyOne",
    },
  ],
  oficinas_mapa: [
    ///PNC///
    {
      id: 1,
      title: "UNIMUJER SAN SALVADOR CENTRO",
      time: "24/7",
      phone: "2529-1426 / 2529-1427",
      direcction:
        "7a. Av. Nte. Entre Alameda Juan Pablo II y 5a Calle Pte.# 418, frente al parque infantil, San Salvador.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/QSFAxYFBshSeSkwf7",
      coordinate: {
        latitude: 13.702771369396112,
        longitude: -89.19446136382496,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 2,
      title: "UNIMUJER APOPA",
      time: "24/7",
      phone: 22417904,
      direcction:
        "Col. Madre Tierra 1, Calle Ppal. #2, Contiguo a Instituto Nacional INA, Apopa, San Salvador",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/Tugew9jTwXmTsQQp9",
      coordinate: {
        latitude: 13.672052167609126,
        longitude: -89.28459662562331,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 3,
      title: "UNIMUJER SOYAPANGO",
      time: "24/7",
      phone: 25291640,
      direcction:
        "Boulevard San Bartolo, Ilopango, frente a INSAFORP y zona franca, Ilopango",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/ibr6vJufJc66wSuy7",
      coordinate: {
        latitude: 13.70064454956582,
        longitude: -89.10484817674235,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 4,
      title: "UNIMUJER SAN SALVADOR DCI",
      time: "24/7",
      phone: 25111114,
      direcction:
        "Col. El Rosal, Calle El Progreso, Edificio 2810, frente a ex CENADE, San Salvador",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/qXez8o7ULoAFSGPm7",
      coordinate: {
        latitude: 13.69713184932305,
        longitude: -89.2197350330792,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 5,
      title: "UNIMUJER SAN MARCOS",
      time: "24/7",
      phone: 22207807,
      direcction:
        "Carretera Antigua a Zacatecoluca, Km. 5.5 , Calle 25 de Abril Ote., Barrio El Centro, San Marcos.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/WNUZqpbU1MG5xFcB7",
      coordinate: {
        latitude: 13.657141943381879,
        longitude: -89.18210743988054,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 6,
      title: "UNIMUJER AGUILARES",
      time: "24/7",
      phone: 23214011,
      direcction:
        "8a. Calle Poniente y 5a. Av. Norte, casa sin #, Barrio Guadalupé,(punto de referencia contiguo a delegación policial) Aguilares, San Salvador.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/YCWLr6v1nyPSjWow9",
      coordinate: {
        latitude: 13.97349980344828,
        longitude: -89.21769720528648,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 7,
      title: "UNIMUJER CIUDAD DELGADO",
      time: "24/7",
      phone: 22769536,
      direcction:
        "Carretera Troncal del Norte, Km. 4 1/2, Col. Bolívar, Calle Ppal.# 51 Ciudad Delgado, San Salvador.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/UwFGXocLjLwNQ2w79",
      coordinate: {
        latitude: 13.71256905260615,
        longitude: -89.17168279325371,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 8,
      title: "UNIMUJER CIUDAD ARCE",
      time: "24/7",
      phone: 23309322,
      direcction:
        "3a. Av. Nte. N° 2B, Costado Ote. Del parque central , Ciudad Arce, La Libertad.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/taaky4trQegtuuz96",
      coordinate: {
        latitude: 13.842256616410651,
        longitude: -89.44601451802257,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 9,
      title: "UNIMUJER MEJICANOS",
      time: "24/7",
      phone: 70742288,
      direcction:
        "Final 5a. Ave. Nte. Y 2a Calle Pte, por el pasaje San Juan, (punto de referencia frente a super selectos) Mejicanos",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/vouZzPKdf1uvkQp39",
      coordinate: {
        latitude: 13.722237410709443,
        longitude: -89.19052579507601,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 10,
      title: "UNIMUJER SAN JUAN OPICO",
      time: "24/7",
      phone: 23473418,
      direcction:
        "2a. Calle Oriente y 4a Av. Norte, Barrio el Centro (punto de referencia contiguo a agencia DELSUR) San Juan Opico",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/zLNtTrbDs2nfjvZt6",
      coordinate: {
        latitude: 13.875931864929589,
        longitude: -89.35823927116421,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 11,
      title: "UNIMUJER SANTA TECLA",
      time: "24/7",
      phone: 22287998,
      direcction:
        "4a. Calle Ote. Y Av. Melvin Jones #2-7, Santa Tecla, La Libertad.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/MCreUoQVN1C1wTJy5",
      coordinate: {
        latitude: 13.672136727236754,
        longitude: -89.28459768895524,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 12,
      title: "UNIMUJER ODAC LA LIBERTAD",
      time: "24/7",
      phone: 23277932,
      direcction:
        "Carretera El Litoral, km 34.5 frente a Malecón Turístico, Puerto de la Libertad.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/TuRowRt2CqX4iqis8",
      coordinate: {
        latitude: 13.487438706449474,
        longitude: -89.32030193988055,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 13,
      title: "UNIMUJER ZARAGOZA",
      time: "24/7",
      phone: 23140481,
      direcction:
        "Ave. Monseñor Oscar Arnulfo Romero, Barrios El Centro, Casa N° 16, Zaragoza",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/8sHnUmq6KRsEMqSWA",
      coordinate: {
        latitude: 13.587951896058748,
        longitude: -89.2873016071152,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 14,
      title: "UNIMUJER CHALATENANGO",
      time: "24/7",
      phone: 23012352,
      direcction:
        "Final Calle San Martín, No.19 Costado sur de Alcaldía municipal de Chalatenango, (punto de referencia frente a oficinas de Claro), Chalatenango.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/ysxZzioJDVL7bo3C6",
      coordinate: {
        latitude: 14.042579712550413,
        longitude: -88.93531062506318,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 15,
      title: "UNIMUJER CARA SUCIA",
      time: "24/7",
      phone: 24370836,
      direcction:
        "6a. Calle Ote Bo. San Martín, Canton Cara Sucia San Francisco Menéndez, Ahuachapán.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/r6MP6vdn7Vgsoa6D8",
      coordinate: {
        latitude: 13.77886154728178,
        longitude: -90.03285439447761,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 16,
      title: "UNIMUJER ACAJUTLA",
      time: "24/7",
      phone: 24523857,
      direcction:
        "Boulevard Coronel Oscar Osorio, contiguo a redondel CEPA, Acajutla, Sonsonate",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/pT1FQo3nHEVq181z5",
      coordinate: {
        latitude: 13.585316968335329,
        longitude: -89.83037369605553,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 17,
      title: "UNIMUJER CHALCHUAPA",
      time: "24/7",
      phone: 24085065,
      direcction:
        "11 Avenida Sur ENTRE 1a y 3a. Calle Ote, Barrios Apaneca, Chalchuapa",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/Ji4xyUVwFY43Xk8i8",
      coordinate: {
        latitude: 13.982562998386966,
        longitude: -89.67366977139082,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 18,
      title: "UNIMUJER SANTA ANA",
      time: "24/7",
      phone: 24208666,
      direcction:
        "25 Calle Pte. Entre 14 y 16 Av. Sur, edificio Mario Calvo, (punto de referencia sobre semáforo la 25 Calle) Santa Ana.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/euPwf3MP1u1CmTv8A",
      coordinate: {
        latitude: 13.984082350249581,
        longitude: -89.56542087745237,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 19,
      title: "UNIMUJER AHUACHAPAN",
      time: "24/7",
      phone: 24208406,
      direcction:
        "Av. Morazán Frente a Colonia IVU a 50 metros de los Bomberos, Ahuachapán.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/ct6tKsZYsovBTah49",
      coordinate: {
        latitude: 13.927603264117025,
        longitude: -89.85158409371932,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 20,
      title: "UNIMUJER METAPAN",
      time: "24/7",
      phone: 24022857,
      direcction:
        "Carretera que de Santa Ana conduce a Metapán Km 110, frente Hospital Nacional Arturo Morales, Metapán, Santa Ana",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/kbN2jJMsp6ihWyZ18",
      coordinate: {
        latitude: 14.325117141021499,
        longitude: -89.44378147932508,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 21,
      title: "UNIMUJER IZALCO",
      time: "24/7",
      phone: 24535364,
      direcction:
        "Barrio San Sebastian, 1° Calle Oriente entre Avenida Morazán y 2° Avenida Sur, Izalco.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/kVuKYZWJLVE8qVmXA",
      coordinate: {
        latitude: 13.747058341159494,
        longitude: -89.67412661838837,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 22,
      title: "UNIMUJER SONSONATE",
      time: "24/7",
      phone: 70707126,
      direcction:
        "Boulevard Coronel Oscar Osorio, Carretera Hacia Acajutla, Kilómetro 76 1/2, (punto de referencia contiguo a cuerpo de bomberos), Sonsonate.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/UfrWwWVZXKbLk8KN6",
      coordinate: {
        latitude: 13.714824141501747,
        longitude: -89.72553502023892,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 23,
      title: "UNIMUJER CONCHAGUA",
      time: "24/7",
      phone: 26803470,
      direcction:
        "Calle 15 de septiembre, contiguo a pasaje El Tamarindo, Barrio la Cruz, (punto de referencia una cuadra al sur de la Alcaldía Municipal) Conchagua, La Unión",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/mbdSGESu7baH9oqM9",
      coordinate: {
        latitude: 13.305653042108139,
        longitude: -87.8624509358139,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 24,
      title: "UNIMUJER LA UNIÓN",
      time: "24/7",
      phone: 26222864,
      direcction:
        "1A. Ave. Nte. y 7a Calle Pte., Centro de Gobierno, Barrio El Centro, (punto de referencia contiguo a correos) La Unión",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/4uXPKfmUqh7oMohV7",
      coordinate: {
        latitude: 13.340810866284352,
        longitude: -87.8463815579034,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 25,
      title: "SUB DELEGACIÓN JIQUILISCO",
      time: "24/7",
      phone: 26638816,
      direcction:
        "1a. Calle Pte. Bo. San José, # 10, Barrio San Antonio, (punto de referencia a una cuadra bajo del Banco Agrícola) Jiquilisco, Usulután",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/LxRMuqX7Ume82iebA",
      coordinate: {
        latitude: 13.328342921118603,
        longitude: -88.57125091578696,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 26,
      title: "UNIMUJER SANTA ROSA DE LIMA",
      time: "24/7",
      phone: 26412129,
      direcction:
        "Carretera Ruta Militar, Colonia Altos del Estadio, Costado Oriente del Estadio Municipal, Santa Rosa de Lima, La Unión",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/ZemDsUEehRN4hQaBA",
      coordinate: {
        latitude: 13.631452060802824,
        longitude: -87.88882697678974,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 27,
      title: "UNIMUJER SAN MIGUEL",
      time: "24/7",
      phone: 26222701,
      direcction:
        "Colonia Belem, 10a Ave. Sur y 9a. Calle Ote, Centro de Gobierno, San Miguel",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/te5CA3TMcYMbFPUU6",
      coordinate: {
        latitude: 13.475543920494825,
        longitude: -88.170429090619,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 28,
      title: "UNIMUJER COJUNTEPEQUE, CUSCATLÁN",
      time: "24/7",
      phone: 23277618,
      direcction:
        "7a. Av. Sur, Barrio San Nicolás, Ex - Instituto Cultural, (punto de referencia Monumento a la Madre) Cojutepeque, Cuscatlán",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/7LfQD6Gt3tFYD7dt6",
      coordinate: {
        latitude: 13.721382384077987,
        longitude: -88.9388702358137,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 29,
      title: "UNIMUJER SUCHITOTO",
      time: "24/7",
      phone: 23351141,
      direcction:
        "4a. Av. Norte y 2a. Calle Oriente. Local Ex -Museo de la Moneda, Barrio San José, Suchitoto, Cuscatlán",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/KpoLXSLkVcqDgG5i7",
      coordinate: {
        latitude: 13.938395103469004,
        longitude: -89.02754827925972,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 30,
      title: "UNIMUJER SENSUNTEPEQUE, CABAÑAS",
      time: "24/7",
      phone: 23822219,
      direcction:
        "Final Av. Libertad, Barrio San Antonio, contiguo Terminal de buses Sensuntepeque, Cabañas.",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/XWwWYoDgtqNcpM8DA",
      coordinate: {
        latitude: 13.877943738425433,
        longitude: -88.62715313030712,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 31,
      title: "UNIMUJER EL PEDREGAL",
      time: "24/7",
      phone: 23556570,
      direcction:
        "Intersección de la Carretera El Litoral y calle a la Herradura, cacerío Los Arcos, Cantón el Pedregal, Rosario de la Paz, La Paz",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/mJKDeyZJrsPVdeGw7",
      coordinate: {
        latitude: 13.463603385820823,
        longitude: -89.00967501204435,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 32,
      title: "UNIMUJER SAN VICENTE",
      time: "24/7",
      phone: 23936747,
      direcction:
        "Barrio San Francisco 6a. Av. Nte y 4a Calle Ote, # 27, (punto de referencia atrás del hospital Nacional Santa Getrudis) San Vicente",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/BuYz8h4drFiCJt1DA",
      coordinate: {
        latitude: 13.641133799418721,
        longitude: -88.78380168703244,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 33,
      title: "UNIMUJER LA NUEVA CONCEPCIÓN",
      time: "24/7",
      phone: 23357031,
      direcction:
        "4° Calle Poniente y 5° Av. Sur, Barrio El Carmen, Nueva Concepción, Chalatenango",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/hSU5PhHXX1Hpo6R2A",
      coordinate: {
        latitude: 14.127061672706086,
        longitude: -89.29392793384068,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 34,
      title: "UNIMUJER ZACATECOLUCA",
      time: "24/7",
      phone: 23488300,
      direcction:
        "Kilómetro 58, Cantón Platanares, Carretera del Litoral hacia Usulután, (punto de referencia redondel de penal de máxima seguridad) Zacatecoluca, La Paz",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/nR7WxMUWwx6aN33e8",
      coordinate: {
        latitude: 13.497800603702435,
        longitude: -88.8629785423284,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 35,
      title: "UNIMUJER MORAZAN",
      time: "24/7",
      phone: 26542132,
      direcction:
        "Final 1a calle Pte y 3a Nte. Barrio El Centro, contiguo a Banco Davivienda, San Francisco Gotera",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/gkG1u11T78qaphYF7",
      coordinate: {
        latitude: 13.697069811650431,
        longitude: -88.10641942748961,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    {
      id: 36,
      title: "UNIMUJER ILOBASCO",
      time: "24/7",
      phone: 23322871,
      direcction:
        "4a Avenida Nte. Barrio San Miguel, (punto de referencia contiguo a Liceo Cristiano) Ilobasco, Cabañas",
      Icon: "PNC.jpg",
      mapURL: "https://maps.app.goo.gl/TVReNmMZxYv7EKh66",
      coordinate: {
        latitude: 13.845176941832252,
        longitude: -88.84891358502571,
      },
      tiposAtencion: `Atención Policial, Auxilio en Crisis, Alojamiento Temporal, Ludoteca`,
    },
    ///PGR///
    {
      id: 37,
      title: "UIAEM San Salvador",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22319539,
      direcction: "Centro de Gobierno, 9ª calle Poniente nivel 1, torre PGR",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/og3o6eNNBBPeYpXj8",
      coordinate: {
        latitude: 13.704617499812654,
        longitude: -89.19731219835788,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 38,
      title: "UIAEM Soyapango",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22458928,
      direcction:
        "Barrio El Progreso, Avenida Las Palmeras, Pasaje Morazán No. 3, Soyapango, San Salvador",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/qCgfok7C2WPpHQxc6",
      coordinate: {
        latitude: 13.705388080903026,
        longitude: -89.1546917646495,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 39,
      title: "UIAEM Sonsonate",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22014128,
      direcction:
        "Colonia San Francisco, 4ª Calle Oriente, No. 22, Sonzacate, Sonsonate",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/zFGUrXBm2WgLGmkj9",
      coordinate: {
        latitude: 13.728183225115007,
        longitude: -89.71415903230243,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 40,
      title: "UIAEM Santa Ana",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22014110,
      direcction:
        "Avenida Fray Felipe de Jesús Moraga Sur entre 2º y 6º Calle Poniente No.6, Santa Ana",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/h2ruMy7CRPyGhRGQ9",
      coordinate: {
        latitude: 13.99663018881077,
        longitude: -89.56335348858265,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 41,
      title: "UIAEM La Libertad",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22458911,
      direcction:
        "6ª Calle Oriente y Av. Dr. José Zablah Touche, casa No. 5-6 San Tecla La Libertad Colonia Útila",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/mJTUapGwR5Ermws7A",
      coordinate: {
        latitude: 13.671417033166552,
        longitude: -89.28131886118665,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 42,
      title: "UIAM Ahuachapán",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22014144,
      direcction: "3a Calle Poniente No. 2-2 Barrio San José, Ahuachapán",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/1pjGG4qJ2XRrn3F97",
      coordinate: {
        latitude: 13.921006803815587,
        longitude: -89.84761205855072,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 43,
      title: "UIAEM Cuscatlán",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 25277443,
      direcction:
        "6ª Calle Oriente, Barrio San Juan, calle a La Estación, casa No. 15, Cojutepeque, Cuscatlán",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/RwKFkxQTfda6BuVc6",
      coordinate: {
        latitude: 13.718794907270578,
        longitude: -88.93143760006161,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 44,
      title: "UIAEM La Paz",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22014172,
      direcction:
        "Calle Dr. Nicolás Peña No. 27, Barrio Candelaria, Zacatecoluca, La Paz",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/MNAvjqodtXeo1Ht99",
      coordinate: {
        latitude: 13.50742122841332,
        longitude: -88.86754931700938,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 45,
      title: "UIAEM Chalatenango",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22014158,
      direcction:
        "Lotificación Santa Emilia kilómetro 77, Caserío Totolco, Chalatenango",
      Icon: "PGR.jpg",
      mapURL: "https://maps.app.goo.gl/PutkxZ1SPdXbPdtG8",
      coordinate: {
        latitude: 14.040879095974097,
        longitude: -88.95816262667044,
      },
      tiposAtencion: `Atención Legal`,
    },
    ///CSJ///
    {
      id: 46,
      title: "SAIV-Centro Judicial Dr. Isidro Menéndez, San Salvador",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22358600,
      direcction:
        "Bulevar Tutunichapa, edificio C, primera planta, San Salvador Centro",
      Icon: "CSJ.jpg",
      mapURL: "https://maps.app.goo.gl/sHoYeigEtEuQqF3z5",
      coordinate: {
        latitude: 13.708628661622718,
        longitude: -89.19915223068635,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 47,
      title: "SAIV-Centro Judicial de Soyapango",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22979100,
      direcction:
        "Cantón y calle Matazano, Pasaje Marsella, Soyapango, San Salvador Este",
      Icon: "CSJ.jpg",
      mapURL: "https://maps.app.goo.gl/HPWNvo5BR9UuS38b7",
      coordinate: {
        latitude: 13.69060054687019,
        longitude: -89.1377046746791,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 48,
      title: "SAIV-Centro Judicial de Ciudad Delgado",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 25279800,
      direcction: "Avenida Juan Bertis, No. 75. CD, San Salvador Centro",
      Icon: "CSJ.jpg",
      mapURL: "https://maps.app.goo.gl/rRG4XcrVkabwDwpq6",
      coordinate: {
        latitude: 13.714327245879495,
        longitude: -89.1702701035147,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 49,
      title: "SAIV-Chalatenango",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 23012352,
      direcction: "Calle San Martin No. 19, Barrio Las Flores, Chalatenango",
      Icon: "CSJ.jpg",
      mapURL: "https://maps.app.goo.gl/P3ZYhDNULfVWzVCt8",
      coordinate: {
        latitude: 14.041031123353587,
        longitude: -88.94030645112805,
      },
      tiposAtencion: `Atención Legal`,
    },
    {
      id: 50,
      title: "SAIV-San Miguel",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 26600688,
      direcction: 'Colonia Hirleman, pasaje "A", block 4, casa #1, San Miguel',
      Icon: "CSJ.jpg",
      mapURL: "https://maps.app.goo.gl/X7xeZSftZFU2C3wS6",
      coordinate: {
        latitude: 13.487659187381686,
        longitude: -88.18975255102059,
      },
      tiposAtencion: `Atención Legal`,
    },
    ///CEM///
    {
      id: 51,
      title: "CEM. LOURDES COLON",
      time: "24/7",
      phone: 25650800,
      direcction:
        "Carretera de Lourdes Colón hacia Sonsonate, entrada a la 600, Cantón Entre Ríos, Colón Dpto. La Libertad",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/N7yzfHPgqLLAGHte7",
      coordinate: {
        latitude: 13.735690507193581,
        longitude: -89.3587405,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 52,
      title: "CEM. SAN MARTIN",
      time: "24/7",
      phone: 25551400,
      direcction:
        "Carretera de Oro, Finca Gran Bretaña, contiguo a Parque El Recreo, San Martín, Dpto. San Salvador",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/PDRLeBhow7HLYueZA",
      coordinate: {
        latitude: 13.733922879256452,
        longitude: -89.06781745099842,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 53,
      title: "CEM. USULUTAN",
      time: "24/7",
      phone: 26091200,
      direcction:
        "9° Calle Oriente y final 8° Avenida Sur, Barrio El Calvario frente a Centro de Gobierno, Depto. de Usulután",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/BC6wNmnFdHpCQhHb7",
      coordinate: {
        latitude: 13.340194014512731,
        longitude: -88.43681609666889,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 54,
      title: "CEM. SAN MIGUEL",
      time: "24/7",
      phone: 26092000,
      direcction:
        "15 Calle Oriente, entre 8° y 10° Avenida Sur, Ex Fenadesal, Colonia Los Angeles, Dpto. de San Miguel",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/ZWKrcUyhyFB1Say39",
      coordinate: {
        latitude: 13.472595873462891,
        longitude: -88.17105326350742,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 55,
      title: "CEM. MORAZAN",
      time: "24/7",
      phone: 26096429,
      direcction:
        "Carretera Ruta Militar, Cantón Llano de Santiago, El Divisadero, Dpto. de Morazán",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/fHFuZ9Ct8j1PEHCz9",
      coordinate: {
        latitude: 13.587175574695133,
        longitude: -88.0759766582853,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 56,
      title: "CEM. SANTA ANA",
      time: "24/7",
      phone: 24042500,
      direcction:
        "Km 61.½ Carretera Panamericana, Finca Santa Teresa, Cantón Chupadero, Dpto. Santa Ana",
      Icon: "CEM.jpg",
      mapURL: "https://maps.app.goo.gl/wG9dq48dhLnsKwzK9",
      coordinate: {
        latitude: 13.957491867511607,
        longitude: -89.58033804028885,
      },
      tiposAtencion: `Salud`,
    },
    ///ONGS///
    {
      id: 57,
      title: "LAS DIGNAS",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 25295800,
      direcction:
        "Avenida Bernal, #16-S. Colonia Satélite, San Salvador, El Salvador",
      Icon: "DIGNAS.jpg",
      mapURL: "https://maps.app.goo.gl/sPwkmoTGb5275z6o9",
      coordinate: {
        latitude: 13.722052893772947,
        longitude: -89.21669034962983,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 58,
      title: "LAS MÉLIDAS",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 22252511,
      direcction:
        "23 Calle Poniente, Calle y Avenida Victorias No 123, Urb. Palomo, Mejicanos, El Salvador",
      Icon: "LASMELIDAS_H.png",
      mapURL: "https://maps.app.goo.gl/aGpKwBK3Pk56Lgez6",
      coordinate: {
        latitude: 13.710966702643143,
        longitude: -89.20079874778258,
      },
      tiposAtencion: `Salud`,
    },
    {
      id: 59,
      title: "ORMUSA",
      time: "8:00AM - 4:00PM LUN-VIER",
      phone: 25560032,
      direcction:
        "7ª calle poniente bis #5265, colonia Escalón. San Salvador, El Salvador",
      Icon: "ORMUSA_H.png",
      mapURL: "https://maps.app.goo.gl/uAJFzAjHBNi1URtJ8",
      coordinate: {
        latitude: 13.709205480860911,
        longitude: -89.24967909011193,
      },
      tiposAtencion: `Salud`,
    },
  ],
};

export default data;
